import { render, staticRenderFns } from "./ChoiceScreen.vue?vue&type=template&id=3be09170&scoped=true"
import script from "./ChoiceScreen.vue?vue&type=script&lang=js"
export * from "./ChoiceScreen.vue?vue&type=script&lang=js"
import style0 from "./ChoiceScreen.vue?vue&type=style&index=0&id=3be09170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be09170",
  null
  
)

export default component.exports